module.exports = __webpack_public_path__ + "static/media/Switchprofile.26f1a778.svg";